// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"47e1e0e7","513":"47e1e0e7","600":"47e1e0e7","707":"47e1e0e7","991":"47e1e0e7"}[chunkId] + ".chunk.css";
};